module.exports = {"ADV_PROPOSAL_REACTIONS_LIKES_POPOVER_TITLE":"Pengguna yang suka","ADV_PROPOSAL_REACTIONS_DISLIKES_POPOVER_TITLE":"Pengguna yang tidak suka"}